export const shareBetHost: string = 'lvbet.pl';
